import { isValidElement, type ReactElement, type ReactNode } from 'react';
import type { TypedObject } from '@portabletext/types';
import type { PortableTextMarkComponentProps } from '@portabletext/react';

export type MarkEl<TMarkType extends string, TValue extends TypedObject> = ReactElement<
    PortableTextMarkComponentProps<TValue> & { markType: TMarkType }
>;

export const isMarkEl = <TMarkType extends string, TValue extends TypedObject>(
    node: ReactNode,
    markType: TMarkType,
): node is MarkEl<TMarkType, TValue> => {
    if (!isValidElement(node)) return false;

    const props = node.props as Record<string, unknown>;
    return props['markType'] === markType;
};
